export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "À Propos",
      services: "Services",
      team: "Équipe",
      presence: "Présence Mondiale",
      news: "Actualités",
      contact: "Contact",
      cta: "Nous contacter",
      book_call: "Réserver un appel",
    },
    hero: {
      overline: "Richild Invest GBC",
      title_1: "Financer le",
      title_2: "Développement Inclusif",
      subtitle: "Une société d'investissement internationale dédiée à la création de valeur durable à travers les marchés émergents et développés.",
      cta_primary: "Découvrir nos services",
      cta_secondary: "Notre présence globale",
      cta_book: "Réserver un appel",
      scroll: "Faire défiler",
    },
    about: {
      overline: "À propos",
      title: "L'excellence au service du développement",
      paragraph_1: "Avec une base prévue à Port Louis, Île Maurice, Richild Invest GBC est une institution d'investissement internationale qui accompagne entrepreneurs, gouvernements et investisseurs institutionnels dans la construction d'un avenir économique durable et inclusif.",
      paragraph_2: "Avec 12 points de présence à travers l'Afrique, l'Europe, l'Amérique et l'Asie, nous combinons une expertise locale approfondie à une perspective globale pour identifier, structurer et déployer des solutions d'investissement à fort impact.",
      stat_1_value: "12",
      stat_1_label: "Présences globale",
      stat_2_value: "4",
      stat_2_label: "Continents couverts",
      stat_3_value: "100%",
      stat_3_label: "Engagement ESG",
    },
    services: {
      overline: "Nos expertises",
      title: "Cinq piliers d'excellence financière",
      subtitle: "Une gamme complète de solutions d'investissement conçues pour répondre aux exigences des institutions et des entrepreneurs ambitieux.",
      items: [
        {
          key: "private-equity",
          title: "Capital-investissement",
          description: "Investissements en capital dans des entreprises à fort potentiel de croissance, avec accompagnement opérationnel et stratégique.",
        },
        {
          key: "debt-finance",
          title: "Financement par la dette",
          description: "Solutions de financement par la dette structurée, adaptées aux besoins spécifiques des entreprises et projets d'infrastructure.",
        },
        {
          key: "trade-finance",
          title: "Financement du commerce international",
          description: "Financement du commerce international, garanties bancaires et solutions de gestion des risques liés aux échanges transfrontaliers.",
        },
        {
          key: "advisory",
          title: "Conseil stratégique",
          description: "Conseil stratégique en fusions-acquisitions, restructurations, et opérations de marché de capitaux pour clients institutionnels.",
        },
        {
          key: "impact-investing",
          title: "Investissement à impact",
          description: "Investissements générant un impact social et environnemental mesurable aux côtés d'un rendement financier compétitif.",
        },
      ],
    },
    presence: {
      overline: "Présence mondiale",
      title: "Nos activités internationales, sur quatre continents",
      subtitle: "Notre objectif de présence stratégique sur 12 sites au cœur des places financières mondiales pour servir nos clients avec proximité et expertise locale.",
    },
    team: {
      overline: "Équipe & Leadership",
      title: "Les femmes et les hommes qui portent notre vision",
      subtitle: "Une équipe de direction expérimentée alliant expertise financière internationale et engagement profond pour le développement inclusif.",
    },
    news: {
      overline: "Actualités",
      title: "Dernières informations",
      subtitle: "Suivez nos investissements, partenariats et publications stratégiques.",
      read_more: "Lire l'article",
      empty: "Aucune actualité publiée pour le moment.",
      back: "Retour aux actualités",
      back_to_list: "Retour à la liste",
      not_found: "Cet article n'existe pas ou a été supprimé.",
      related: "Articles similaires",
    },
    contact: {
      overline: "Contact",
      title: "Démarrons une conversation",
      subtitle: "Nos équipes sont à votre disposition pour étudier vos projets d'investissement.",
      info_title: "Siège social",
      address: "Port Louis, Île Maurice",
      dakar_title: "Bureau Afrique de l'Ouest",
      dakar_lines: ["Richild Invest SA", "Allées Canal IV, Point-E", "BP 25163 Dakar Fann, Sénégal"],
      email: "info@richildinvest.com",
      hours_label: "Horaires",
      hours: "Lundi - Vendredi : 9h00 - 18h00",
      form: {
        name: "Nom complet",
        email: "Adresse e-mail",
        company: "Société (optionnel)",
        subject: "Sujet",
        message: "Votre message",
        consent: "J'accepte que mes données soient traitées conformément à la politique de confidentialité.",
        submit: "Envoyer le message",
        submitting: "Envoi en cours...",
        success: "Nous accusons réception de votre message concernant les opportunités d'investissement auprès de Richild Invest et vous remercions par ailleurs de l'intérêt que vous portez à notre vision du développement, de la croissance et de l'avenir.\n\nNotre équipe chargée des relations avec les investisseurs, examinera votre demande et vous contactera dans un délai de trois jours ouvrables.\n\nCordiales salutations.",
        error: "Une erreur est survenue. Veuillez réessayer.",
        network_error: "Connexion au serveur impossible. Vérifiez votre connexion internet",
        validation_error: "Données invalides",
      },
    },
    footer: {
      tagline: "Financer le Développement Inclusif",
      description: "Société d'investissement internationale basée à Port Louis, Île Maurice.",
      nav_title: "Navigation",
      legal_title: "Légal",
      privacy: "Politique de confidentialité",
      cookies: "Gestion des cookies",
      terms: "Conditions d'utilisation",
      contact_title: "Contact",
      rights: "Tous droits réservés.",
    },
    cookies: {
      title: "Respect de votre vie privée",
      message: "Nous utilisons des cookies pour analyser notre trafic (Google Analytics) et améliorer votre expérience. Aucun cookie de mesure n'est déposé tant que vous n'avez pas donné votre accord explicite, conformément au RGPD et aux recommandations de la CNIL.",
      accept: "Tout accepter",
      decline: "Tout refuser",
      learn_more: "En savoir plus",
      settings: "Gérer mes préférences",
      reopen: "Modifier mes préférences",
      saved_accepted: "Préférences enregistrées : cookies analytiques activés.",
      saved_declined: "Préférences enregistrées : seuls les cookies essentiels sont utilisés.",
    },
    lead: {
      overline: "Ressource exclusive",
      title: "Rapport ESG Afrique 2026",
      subtitle: "Téléchargez notre analyse exclusive sur les opportunités d'investissement responsable en Afrique : tendances macro, secteurs prioritaires, cadre réglementaire et études de cas.",
      bullet_1: "Analyse de 12 marchés africains stratégiques",
      bullet_2: "Cadre ESG et alignement aux ODD des Nations Unies",
      bullet_3: "Études de cas d'investissement à impact",
      cta: "Recevoir le rapport",
      modal_title: "Recevez le rapport par e-mail",
      modal_subtitle: "Renseignez vos coordonnées professionnelles. Vous recevrez le rapport ESG dès sa publication officielle.",
      form_name: "Nom complet",
      form_email: "E-mail professionnel",
      form_company: "Société / Institution",
      form_consent: "J'accepte que Richild Invest GBC utilise mes coordonnées pour m'envoyer le rapport et des communications occasionnelles. Je peux me désinscrire à tout moment.",
      form_submit: "Envoyer ma demande",
      form_submitting: "Envoi en cours...",
      form_success: "Merci ! Le rapport vient de vous être envoyé par e-mail. Vous pouvez également le télécharger directement ci-dessous.",
      form_error: "Une erreur est survenue. Veuillez réessayer.",
      download_now: "Télécharger maintenant",
      close: "Fermer",
    },
    legal: {
      back: "Retour à l'accueil",
      notice_title: "Mentions légales",
      notice_updated: "Dernière mise à jour : février 2026",
      privacy_title: "Politique de confidentialité",
      privacy_updated: "Dernière mise à jour : février 2026",
    },
    admin: {
      login_title: "Espace Administration",
      login_subtitle: "Veuillez vous authentifier pour accéder au tableau de bord.",
      email: "E-mail",
      password: "Mot de passe",
      login: "Se connecter",
      logging_in: "Connexion...",
      invalid: "Identifiants invalides.",
      dashboard_title: "Tableau de bord",
      news_tab: "Actualités",
      contact_tab: "Messages",
      logout: "Déconnexion",
      new_article: "Nouvel article",
      edit: "Modifier",
      delete: "Supprimer",
      save: "Enregistrer",
      cancel: "Annuler",
      published: "Publié",
      draft: "Brouillon",
      confirm_delete: "Confirmer la suppression ?",
      mark_read: "Marquer comme lu",
      unread: "Non lu",
      read: "Lu",
      no_news: "Aucune actualité.",
      no_messages: "Aucun message.",
      team_tab: "Équipe",
      legal_tab: "Documents juridiques",
      no_team: "Aucun membre.",
      no_legal: "Aucun document.",
      new_member: "Nouveau membre",
      new_document: "Nouveau document",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      team: "Team",
      presence: "Global Presence",
      news: "News",
      contact: "Contact",
      cta: "Contact us",
      book_call: "Book a call",
    },
    hero: {
      overline: "Richild Invest GBC",
      title_1: "Financing",
      title_2: "Inclusive Development",
      subtitle: "An international investment firm dedicated to creating sustainable value across emerging and developed markets.",
      cta_primary: "Explore our services",
      cta_secondary: "Our global presence",
      cta_book: "Book a call",
      scroll: "Scroll",
    },
    about: {
      overline: "About us",
      title: "Excellence serving development",
      paragraph_1: "With Headquartered planned in Port Louis, Mauritius, Richild Invest GBC is an international investment institution supporting entrepreneurs, governments, and institutional investors in building a sustainable and inclusive economic future.",
      paragraph_2: "With 12 présences across Africa, Europe, America, and Asia, we combine deep local expertise with a global perspective to identify, structure, and deploy high-impact investment solutions.",
      stat_1_value: "12",
      stat_1_label: "Global presence",
      stat_2_value: "4",
      stat_2_label: "Continents covered",
      stat_3_value: "100%",
      stat_3_label: "ESG commitment",
    },
    services: {
      overline: "Our expertise",
      title: "Five pillars of financial excellence",
      subtitle: "A complete range of investment solutions designed to meet the requirements of institutions and ambitious entrepreneurs.",
      items: [
        {
          key: "private-equity",
          title: "Private Equity",
          description: "Equity investments in high-growth companies, combined with operational and strategic support.",
        },
        {
          key: "debt-finance",
          title: "Debt Finance",
          description: "Structured debt financing solutions tailored to the specific needs of companies and infrastructure projects.",
        },
        {
          key: "trade-finance",
          title: "Trade Finance",
          description: "International trade financing, bank guarantees, and risk management solutions for cross-border transactions.",
        },
        {
          key: "advisory",
          title: "Advisory",
          description: "Strategic advisory on mergers & acquisitions, restructurings, and capital markets operations for institutional clients.",
        },
        {
          key: "impact-investing",
          title: "Impact Investing",
          description: "Investments generating measurable social and environmental impact alongside competitive financial returns.",
        },
      ],
    },
    presence: {
      overline: "Global presence",
      title: "Our Global Operations, Four Continents",
      subtitle: "Our operational reach is in 12 strategic locations in the heart of global financial centers so we can serve our clients with local expertise and a personal touch.",
    },
    team: {
      overline: "Team & Leadership",
      title: "The people behind our vision",
      subtitle: "An experienced leadership team combining international financial expertise with a deep commitment to inclusive development.",
    },
    news: {
      overline: "News",
      title: "Latest updates",
      subtitle: "Follow our investments, partnerships, and strategic publications.",
      read_more: "Read article",
      empty: "No news published yet.",
      back: "Back to news",
      back_to_list: "Back to list",
      not_found: "This article does not exist or has been deleted.",
      related: "Related articles",
    },
    contact: {
      overline: "Contact",
      title: "Let's start a conversation",
      subtitle: "Our teams are available to discuss your investment projects.",
      info_title: "Headquarters",
      address: "Port Louis, Mauritius",
      dakar_title: "West Africa Office",
      dakar_lines: ["Richild Invest SA", "Allées Canal IV, Point-E", "BP 25163 Dakar Fann, Senegal"],
      email: "info@richildinvest.com",
      hours_label: "Office hours",
      hours: "Monday - Friday: 9:00 AM - 6:00 PM",
      form: {
        name: "Full name",
        email: "Email address",
        company: "Company (optional)",
        subject: "Subject",
        message: "Your message",
        consent: "I agree that my data will be processed according to the privacy policy.",
        submit: "Send message",
        submitting: "Sending...",
        success: "We acknowledge receipt of your message regarding investment opportunities with Richild Invest. We appreciate your interest in our vision of business growth and of the future.\n\nOur Investor Relations team will review your inquiry and contact you within 2 business days.\n\nRegards.",
        error: "An error occurred. Please try again.",
        network_error: "Unable to reach the server. Please check your internet connection",
        validation_error: "Invalid data",
      },
    },
    footer: {
      tagline: "Financing Inclusive Development",
      description: "International investment firm headquartered in Port Louis, Mauritius.",
      nav_title: "Navigation",
      legal_title: "Legal",
      privacy: "Privacy policy",
      cookies: "Cookie settings",
      terms: "Terms of use",
      contact_title: "Contact",
      rights: "All rights reserved.",
    },
    cookies: {
      title: "We respect your privacy",
      message: "We use cookies to analyze our traffic (Google Analytics) and improve your experience. No measurement cookie is set until you give your explicit consent, in accordance with GDPR and CNIL guidelines.",
      accept: "Accept all",
      decline: "Decline all",
      learn_more: "Learn more",
      settings: "Manage preferences",
      reopen: "Change my preferences",
      saved_accepted: "Preferences saved: analytics cookies enabled.",
      saved_declined: "Preferences saved: only essential cookies are used.",
    },
    lead: {
      overline: "Exclusive resource",
      title: "Africa ESG Report 2026",
      subtitle: "Download our exclusive analysis on responsible investment opportunities in Africa: macro trends, priority sectors, regulatory framework, and case studies.",
      bullet_1: "Analysis of 12 strategic African markets",
      bullet_2: "ESG framework and alignment with UN SDGs",
      bullet_3: "Impact investment case studies",
      cta: "Get the report",
      modal_title: "Receive the report by email",
      modal_subtitle: "Provide your professional details. You will receive the ESG report upon official publication.",
      form_name: "Full name",
      form_email: "Professional email",
      form_company: "Company / Institution",
      form_consent: "I agree that Richild Invest GBC may use my details to send me the report and occasional communications. I can unsubscribe at any time.",
      form_submit: "Submit my request",
      form_submitting: "Submitting...",
      form_success: "Thank you! The report has just been sent to your inbox. You can also download it directly below.",
      form_error: "An error occurred. Please try again.",
      download_now: "Download now",
      close: "Close",
    },
    legal: {
      back: "Back to home",
      notice_title: "Legal Notice",
      notice_updated: "Last updated: February 2026",
      privacy_title: "Privacy Policy",
      privacy_updated: "Last updated: February 2026",
    },
    admin: {
      login_title: "Administration",
      login_subtitle: "Please authenticate to access the dashboard.",
      email: "Email",
      password: "Password",
      login: "Sign in",
      logging_in: "Signing in...",
      invalid: "Invalid credentials.",
      dashboard_title: "Dashboard",
      news_tab: "News",
      contact_tab: "Messages",
      logout: "Logout",
      new_article: "New article",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      published: "Published",
      draft: "Draft",
      confirm_delete: "Confirm deletion?",
      mark_read: "Mark as read",
      unread: "Unread",
      read: "Read",
      no_news: "No news.",
      no_messages: "No messages.",
      team_tab: "Team",
      legal_tab: "Legal Documents",
      no_team: "No team members.",
      no_legal: "No documents.",
      new_member: "New member",
      new_document: "New document",
    },
  },
};
